/* HCI storefront interactions. Account functionality is native Shopify. */
(function () {
  "use strict";

  var menus = function () {
    return Array.prototype.slice.call(document.querySelectorAll("[data-dd-menu]"));
  };

  function closeMenus(except) {
    menus().forEach(function (menu) {
      if (menu === except) return;
      menu.classList.add("hidden");
      var dropdown = menu.closest("[data-dd]");
      var toggle = dropdown && dropdown.querySelector("[data-dd-toggle]");
      if (toggle) toggle.setAttribute("aria-expanded", "false");
    });
  }

  var mobileNav = document.querySelector("[data-mobile-nav]");
  var mobileNavToggle = document.querySelector("[data-mobile-nav-toggle]");

  function setMobileNav(open, returnFocus) {
    if (!mobileNav || !mobileNavToggle) return;
    mobileNav.hidden = !open;
    mobileNavToggle.setAttribute("aria-expanded", open ? "true" : "false");
    mobileNavToggle.setAttribute("aria-label", open ? "Close menu" : "Open menu");
    var openIcon = mobileNavToggle.querySelector("[data-mobile-nav-open-icon]");
    var closeIcon = mobileNavToggle.querySelector("[data-mobile-nav-close-icon]");
    if (openIcon) openIcon.classList.toggle("hidden", open);
    if (closeIcon) closeIcon.classList.toggle("hidden", !open);
    document.body.classList.toggle("mobile-nav-open", open);
    if (open) {
      closeMenus();
    } else if (returnFocus) {
      mobileNavToggle.focus();
    }
  }

  document.addEventListener("click", function (event) {
    var accessDialog = document.querySelector("[data-trade-access-dialog]");
    if (event.target.closest("[data-close-trade-access]")) {
      if (accessDialog) accessDialog.close();
      return;
    }
    var navButton = event.target.closest("[data-mobile-nav-toggle]");
    if (navButton) {
      event.stopPropagation();
      setMobileNav(mobileNav.hidden, false);
      return;
    }

    if (mobileNav && !mobileNav.hidden) {
      if (event.target.closest("[data-mobile-nav] a")) setMobileNav(false, false);
      else if (!event.target.closest("[data-mobile-nav]")) setMobileNav(false, false);
    }

    var accountButton = event.target.closest("[data-open-account]");

    if (accountButton) {
      event.preventDefault();
      setMobileNav(false, false);
      if (accessDialog) {
        accessDialog.showModal();
        return;
      }
      var accountHost = document.querySelector("shopify-account.hci-account-launcher");
      var accountRoot = accountHost && accountHost.shadowRoot;
      if (accountRoot && !accountRoot.querySelector("style[data-hci-account-overrides]")) {
        var accountOverrides = document.createElement("style");
        accountOverrides.setAttribute("data-hci-account-overrides", "");
        accountOverrides.textContent = [
          'nav[aria-label="Quick links"]{display:none!important}',
          '.hci-account-brand{display:flex;align-items:center;gap:10px;padding:16px 18px;background:#fff;color:#0f172a;border-bottom:1px solid #e2e8f0}',
          '.hci-account-brand__logo{width:28px;height:28px;object-fit:contain}',
          '.hci-account-brand__copy{display:grid;gap:1px;line-height:1.2}',
          '.hci-account-brand__name{font-size:13px;font-weight:800;letter-spacing:.01em}',
          '.hci-account-brand__sub{font-size:10px;font-weight:650;letter-spacing:.08em;text-transform:uppercase;color:#64748b}',
          '.hci-account-apply{display:grid;gap:10px;padding:18px;color:#475569;font-size:12px;line-height:1.5;border-bottom:1px solid #e2e8f0}',
          '.hci-account-apply a{display:block;padding:11px 14px;border-radius:5px;background:#d60a2e;color:#fff;text-align:center;font-weight:750;text-decoration:none}',
          '.hci-account-apply a:hover{text-decoration:underline}'
        ].join('');
        accountRoot.appendChild(accountOverrides);
      }
      if (accountRoot && !accountRoot.querySelector(".hci-account-brand")) {
        var accountPanel = accountRoot.querySelector(".account");
        if (accountPanel) {
          var accountBrand = document.createElement("div");
          accountBrand.className = "hci-account-brand";
          var accountLogo = document.createElement("img");
          accountLogo.className = "hci-account-brand__logo";
          accountLogo.src = accountHost.getAttribute("data-hci-logo");
          accountLogo.alt = "";
          var accountCopy = document.createElement("span");
          accountCopy.className = "hci-account-brand__copy";
          var accountName = document.createElement("span");
          accountName.className = "hci-account-brand__name";
          accountName.textContent = "HCI Distribution";
          var accountSub = document.createElement("span");
          accountSub.className = "hci-account-brand__sub";
          accountSub.textContent = "Trade customer access";
          accountCopy.appendChild(accountName);
          accountCopy.appendChild(accountSub);
          accountBrand.appendChild(accountLogo);
          accountBrand.appendChild(accountCopy);
          accountPanel.insertBefore(accountBrand, accountPanel.firstChild);
        }
      }
      if (accountRoot) {
        var accountHeading = accountRoot.querySelector(".account__heading");
        if (accountHeading) accountHeading.textContent = "Already approved? Sign in";
      }
      if (accountRoot && !accountRoot.querySelector(".hci-account-apply")) {
        var accountBody = accountRoot.querySelector(".account");
        if (accountBody) {
          var accountApply = document.createElement("div");
          accountApply.className = "hci-account-apply";
          var accountApplyPrompt = document.createElement("span");
          accountApplyPrompt.textContent = "New to the website? Signing in does not apply for a trade account. Complete the registration form first, even if you already buy from HCI.";
          var accountApplyLink = document.createElement("a");
          accountApplyLink.href = "/pages/contact?view=trade-account";
          accountApplyLink.textContent = "Register for trade access";
          accountApply.appendChild(accountApplyPrompt);
          accountApply.appendChild(accountApplyLink);
          var brandPanel = accountBody.querySelector(".hci-account-brand");
          accountBody.insertBefore(accountApply, brandPanel ? brandPanel.nextSibling : accountBody.firstChild);
        }
      }
      var accountLauncher = accountRoot ? accountRoot.querySelector(".account-button") : null;
      if (accountLauncher) accountLauncher.click();
      else if (accountButton.dataset.accountFallback) window.location.assign(accountButton.dataset.accountFallback);
      return;
    }

    var toggle = event.target.closest("[data-dd-toggle]");

    if (toggle) {
      event.stopPropagation();
      var dropdown = toggle.closest("[data-dd]");
      var menu = dropdown && dropdown.querySelector("[data-dd-menu]");
      if (!menu) return;

      var willOpen = menu.classList.contains("hidden");
      closeMenus(menu);
      menu.classList.toggle("hidden", !willOpen);
      toggle.setAttribute("aria-expanded", willOpen ? "true" : "false");
      return;
    }

    if (!event.target.closest("[data-dd-menu]")) closeMenus();
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      closeMenus();
      if (mobileNav && !mobileNav.hidden) setMobileNav(false, true);
    }
  });

  window.addEventListener("resize", function () {
    if (window.innerWidth > 767 && mobileNav && !mobileNav.hidden) setMobileNav(false, false);
  });

  function initStockCarousel(carousel) {
    var track = carousel.querySelector("[data-stock-track]");
    var viewport = carousel.querySelector("[data-stock-viewport]");
    var previous = carousel.querySelector("[data-stock-prev]");
    var next = carousel.querySelector("[data-stock-next]");
    var toggle = carousel.querySelector("[data-stock-toggle]");
    var status = carousel.querySelector("[data-stock-status]");
    var counter = carousel.querySelector("[data-stock-counter]");
    if (!track || !viewport) return;

    var items = Array.prototype.slice.call(track.querySelectorAll("[data-stock-item]"));
    var count = items.length;
    var index = 0;
    var visible = 3;
    var timer = null;
    var moving = false;
    var paused = false;
    var userPaused = false;
    var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    function rowHeight() {
      return items[0] ? items[0].getBoundingClientRect().height : 0;
    }

    function updateStatus() {
      if (!status || !count) return;
      var first = (index % count) + 1;
      var last = ((index + Math.min(visible, count) - 1) % count) + 1;
      status.textContent = "Showing stock items " + first + " to " + last + " of " + count;
      if (counter) counter.textContent = String(first).padStart(2, "0") + " / " + String(count).padStart(2, "0");
    }

    function render(animate) {
      track.classList.toggle("is-moving", animate && !reducedMotion);
      track.style.transform = "translate3d(0," + (-index * rowHeight()) + "px,0)";
      updateStatus();
    }

    function clearClones() {
      track.querySelectorAll("[data-stock-clone]").forEach(function (clone) {
        clone.remove();
      });
    }

    function configure() {
      clearClones();
      visible = parseInt(window.getComputedStyle(carousel).getPropertyValue("--stock-visible"), 10) || 3;
      visible = Math.min(visible, count);
      index = 0;
      moving = false;

      if (count > visible) {
        items.slice(0, visible).forEach(function (item) {
          var clone = item.cloneNode(true);
          clone.setAttribute("data-stock-clone", "");
          clone.setAttribute("aria-hidden", "true");
          clone.setAttribute("tabindex", "-1");
          track.appendChild(clone);
        });
      }

      if (previous) previous.disabled = count <= visible;
      if (next) next.disabled = count <= visible;
      if (toggle) {
        toggle.disabled = count <= visible || reducedMotion;
        if (reducedMotion) toggle.setAttribute("aria-label", "Automatic stock rotation disabled");
      }
      render(false);
    }

    function forward() {
      if (moving || count <= visible) return;
      moving = true;
      index += 1;
      render(true);
      if (reducedMotion) {
        if (index >= count) index = 0;
        moving = false;
        render(false);
      }
    }

    function backward() {
      if (moving || count <= visible) return;
      moving = true;

      if (index === 0) {
        index = count;
        render(false);
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            index = count - 1;
            render(true);
            if (reducedMotion) moving = false;
          });
        });
      } else {
        index -= 1;
        render(true);
        if (reducedMotion) moving = false;
      }
    }

    function stopAutoplay() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    function startAutoplay() {
      stopAutoplay();
      if (!paused && !userPaused && !document.hidden && !reducedMotion && count > visible) {
        timer = window.setInterval(forward, 5050);
      }
    }

    track.addEventListener("transitionend", function (event) {
      if (event.propertyName !== "transform") return;
      if (index >= count) {
        index = 0;
        render(false);
      }
      moving = false;
    });

    if (previous) previous.addEventListener("click", backward);
    if (next) next.addEventListener("click", forward);
    if (toggle) {
      toggle.addEventListener("click", function () {
        userPaused = !userPaused;
        toggle.setAttribute("aria-pressed", userPaused ? "true" : "false");
        toggle.setAttribute("aria-label", userPaused ? "Resume stock rotation" : "Pause stock rotation");
        var pauseIcon = toggle.querySelector("[data-stock-pause-icon]");
        var playIcon = toggle.querySelector("[data-stock-play-icon]");
        if (pauseIcon) pauseIcon.classList.toggle("hidden", userPaused);
        if (playIcon) playIcon.classList.toggle("hidden", !userPaused);
        if (userPaused) stopAutoplay();
        else startAutoplay();
      });
    }

    carousel.addEventListener("focusin", function () {
      paused = true;
      stopAutoplay();
    });
    carousel.addEventListener("focusout", function (event) {
      if (carousel.contains(event.relatedTarget)) return;
      paused = false;
      startAutoplay();
    });
    document.addEventListener("visibilitychange", startAutoplay);

    var resizeTimer;
    window.addEventListener("resize", function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        configure();
        startAutoplay();
      }, 150);
    });

    configure();
    startAutoplay();
  }

  document.querySelectorAll("[data-stock-carousel]").forEach(initStockCarousel);
})();
